import React from "react";
import { clamp, isNumber, TypeOrFunction } from "@hex-insights/core";

export function useOrderedLabels<T>(labels: T[], initialLabel?: TypeOrFunction<T>) {
	const [label, setLabel] = React.useState(initialLabel ?? labels[0]);
	const index = labels.indexOf(label);

	React.useEffect(() => {
		if (!labels.includes(label)) {
			setLabel(labels[0]);
		}
	}, [labels, label]);

	const incrementLabel = React.useCallback(
		(step?: number | Event) => {
			const stepNumber = isNumber(step) ? step : 1;
			setLabel((prev) => {
				const prevIndex = labels.indexOf(prev);
				return labels[clamp(0, prevIndex + stepNumber, labels.length - 1)];
			});
		},
		[labels],
	);

	const decrementLabel = React.useCallback(
		(step?: number | Event) => {
			const stepNumber = isNumber(step) ? step : 1;
			setLabel((prev) => {
				const prevIndex = labels.indexOf(prev);
				return labels[clamp(0, prevIndex - stepNumber, labels.length - 1)];
			});
		},
		[labels],
	);

	return { label, setLabel, labelIndex: index, incrementLabel, decrementLabel };
}
